class ColorContraste {
    constructor(color, contraste) {
        this.color = color;
        this.contraste = contraste;
    }
}

export { ColorContraste as default };
